import { render } from "./GridHeaderCell.vue?vue&type=template&id=3c47d8c5&scoped=true&ts=true"
import script from "./GridHeaderCell.vue?vue&type=script&lang=ts"
export * from "./GridHeaderCell.vue?vue&type=script&lang=ts"

import "./GridHeaderCell.vue?vue&type=style&index=0&id=3c47d8c5&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c47d8c5"]])

export default __exports__